import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ArrowLeftRight, PackageOpen, Truck } from 'lucide-react';
import { StatCard, WidgetPanel } from './DashboardShared';
import { stockTransfers, locationLabelOf, branchesOf, warehouses } from '../../../data/store';

export const TransportModule = ({ org }) => {
  const metrics = useMemo(() => {
    const orgTransfers = stockTransfers.filter(t => t.orgId === org.id);
    const orgBranches = branchesOf(org.id);
    const orgWarehouses = warehouses.filter(w => w.orgId === org.id);
    
    let inTransit = 0;
    let pendingReceipts = 0;
    
    orgTransfers.forEach(t => {
      if (t.status === 'transit') {
        inTransit++;
        pendingReceipts++;
      } else if (t.status === 'approved') {
        pendingReceipts++;
      }
    });

    return { inTransit, pendingReceipts, transfers: orgTransfers };
  }, [org.id]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.15em] text-[#0d0d0d] border-b border-slate-100 pb-3 mt-4">
        <ArrowLeftRight size={16} className="text-[var(--theme-primary)]" />
        Stock Transport
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard icon={ArrowLeftRight} label="Transfers In Transit" value={metrics.inTransit} iconColor="#f59e0b" />
        <StatCard icon={PackageOpen} label="Pending Receipts" value={metrics.pendingReceipts} iconColor="#3b82f6" />
      </div>

      <div className="grid grid-cols-1 gap-6">
        <WidgetPanel title="Transfer Status Board">
           <div className="flex flex-col gap-4 h-full">
             <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex flex-col gap-2">
               <h4 className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 border-b border-slate-200 pb-2">Requested / Approved</h4>
               <div className="text-2xl font-bold text-slate-700">{metrics.transfers.filter(t => t.status === 'requested' || t.status === 'approved').length}</div>
             </div>
             <div className="bg-amber-50/50 border border-amber-100 rounded-2xl p-4 flex flex-col gap-2">
               <h4 className="text-[10px] font-bold uppercase tracking-[0.15em] text-amber-600 border-b border-amber-100 pb-2">In Transit</h4>
               <div className="text-2xl font-bold text-amber-700">{metrics.inTransit}</div>
             </div>
             <div className="bg-emerald-50/50 border border-emerald-100 rounded-2xl p-4 flex flex-col gap-2">
               <h4 className="text-[10px] font-bold uppercase tracking-[0.15em] text-emerald-600 border-b border-emerald-100 pb-2">Received (Total)</h4>
               <div className="text-2xl font-bold text-emerald-700">{metrics.transfers.filter(t => t.status === 'received').length}</div>
             </div>
           </div>
        </WidgetPanel>
      </div>
    </div>
  );
};

TransportModule.propTypes = {
  org: PropTypes.object.isRequired,
};
